/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Button, Alert, InputGroup, Card,
  NavItem, NavLink, Nav, TabPane, TabContent, CardBody, CardHeader,
} from 'reactstrap';

import classnames from 'classnames';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { useHistory } from 'react-router-dom';

import {
  Formik, Field, FieldArray, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull, update } from 'lodash';
import SpyScraperButton from '../Common/SpyScraperButton';
import ItemFieldset from '../Item/ItemFieldset';
import { post, get } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';
import TagSelector from '../Common/TagSelector';

import GoogleFiles from '../Common/GoogleFiles';
import CompatibilityFieldset from '../Device/CompatibilityFieldset';
import AttributesFieldset from '../Common/AttributesFieldset';
import ImagesFieldset from '../Common/ImagesFieldset';
import BaseGrid from '../Common/BaseGrid';
import ListingMultiSelect from './ListingMultiSelect';
import EncompassMapper from '../Mappers/EncompassMapper';
import ListingBoxPicker from './ListingBoxPicker';

const newChannel = (channel) => ({
  channel,
  remote_id: null,
  price_override: null,
  visibility: null,
});

const priceOverrideExceedsDefault = (priceOverride, defaultPrice) => {
  if (priceOverride === null || priceOverride === undefined || priceOverride === '') return false;
  if (defaultPrice === null || defaultPrice === undefined || defaultPrice === '') return false;

  const overrideValue = Number(priceOverride);
  const defaultValue = Number(defaultPrice);

  return Number.isFinite(overrideValue)
    && Number.isFinite(defaultValue)
    && overrideValue > defaultValue;
};

function ListingForm(props) {
  const {
    actionUrl,
    entity,
    t,
    duplicate,
  } = props;
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [loadingProfile, setLoadingProfile] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [addToCartSearch, setAddToCartSearch] = useState(false);
  const [relatedSearch, setRelatedSearch] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [profile, setProfile] = useState(false);
  const [signal, setSignal] = useState(0);
  const [matchedCats, setMatchedCats] = useState([]);
  const [averagePrice, setAveragePrice] = useState(0);
  const [aiLoading, setAILoading] = useState(false);
  const [mapSearch, setMapSearch] = useState(null);

  const mapSearchRef = useRef(null);

  const save = async (values) => {
    try {
      setLoading(true);
      const result = await post(actionUrl, values);
      setErrorMessage(null);

      toastr.success(`Listing ID ${result.id} saved`, 'Success');
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const updateMatchedCats = async (tags) => {
    const tagIds = tags.map((x) => (x.id)).join(',');

    if (tagIds.length > 0) {
      const result = await get('/api/listings/matches?tagIds='.concat(tagIds));
      setMatchedCats(result);
    } else {
      setMatchedCats([]);
    }
  };

  const updateAveragePrice = async (tags, pn) => {
    const tagIds = tags.map((x) => x.id).join(',');

    try {
      if (tagIds.length > 0) {
        const response = await get(`/api/listings/average-price?tagIds=${tagIds}&pn=${pn}`);
        setAveragePrice(response.averagePrice);
      } else {
        setAveragePrice('--');
      }
    } catch (error) {
      // Handle 404 error
      if (error.response && error.response.status === 404) {
        setAveragePrice('--');
      } else {
        setAveragePrice('Error');
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const prof = await get(url.GET_PROFILE.replace(/:id/, entity.profile_id));

        setProfile(prof);
      } catch (e) {
        setErrorMessage(e.message);
      } finally {
        setLoadingProfile(false);
      }
    };

    if (entity.profile_id != null) {
      fetchData();
    }
  }, [entity]);

  let attributeSchema = Yup.array().of(
    Yup.object().shape({
      label: Yup.string().required(t('Attribute label is required')),
      code: Yup.string().matches(/^[^{}]+$/, t('Shortcodes detected')),
    }),
  );

  const generateDescription = async (data, sfv) => {
    try {
      setAILoading(true);
      const desc = await post('/api/openai/marketing-description', data);

      sfv('description', desc.content);
    } catch (e) {
      setErrorMessage(e.message);
    } finally {
      setAILoading(false);
    }
  };

  if (profile !== false) {
    for (let i = 0; i < profile.attributes.length; i += 1) {
      const label = profile.attributes[i].label.replace(/[^a-z0-9-]/i, '-');
      const { pattern, message } = profile.attributes[i];

      // eslint-disable-next-line eqeqeq
      if (profile.attributes[i].required == true) {
        // eslint-disable-next-line no-param-reassign
        attributeSchema = attributeSchema.test(`has-label-${label}`, props.t(`${profile.attributes[i].label} is required by profile!`), (value) => (
          value.some((obj) => (
            obj.label === profile.attributes[i].label
          ))
        ));
      }

      // eslint-disable-next-line no-param-reassign
      attributeSchema = attributeSchema.test(`has-pattern-${label}`, `${profile.attributes[i].label}: ${message}`, (value) => (
        profile.attributes[i].required === 0 || value.some((obj) => {
          if (obj.code !== undefined && obj.label === profile.attributes[i].label) {
            return obj.code.match(new RegExp(pattern));
          }

          return false;
        })
      ));
    }
  }

  const ValidationSchema = Yup.object().shape({
    title: Yup.string().required(t('Title is required')).matches(/^[^{}]+$/, t('Shortcodes detected')),
    condition: Yup.mixed().required(t('Condition is required')),
    sku: Yup
      .string()
      .required(t('Sku is required'))
      .matches(/^sj-/, t('Must begin with "sj-"'))
      .matches(/^[^{}]+$/, t('Shortcodes detected')),
    brand: Yup
      .string()
      .required(t('Brand is required'))
      .matches(/^[A-Z]+/, t('Must begin with a capital letter'))
      .matches(/^[^{}]+$/, t('Shortcodes detected')),
    upc: Yup
      .string()
      .nullable()
      .matches(/^[0-9]{12}[0-9]?$/, t('Must be 12 or 13 digits')),
    ship_weight: Yup
      .number()
      .moreThan(0, t('Must be greater than 0')),
    ship_dims: Yup
      .string()
      .matches(/^[0-9.]+x[0-9.]+x[0-9.]+?$/i, t('Must be in the format LxWxH')),
    description: Yup
      .string().nullable()
      .matches(/^[^{}]+$/, t('Shortcodes detected')),
    important: Yup
      .string().nullable(),
    price: Yup.number().min(0.5).required(t('Default price is required')),
    tags: Yup.array().of(
      Yup.object().shape({
        label: Yup.string()
          .required(t('Tag is required'))
          .matches(/^[\w -/]+$/, { message: t('Tags can only contain letters, numbers, dashes, and spaces') }),
        id: Yup.number(),
      }),
    ).min(2, t('At least 2 tags are required')),
    images: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(t('Label is required')),
        url: Yup.string().url(t('Must be a URL')).required(t('URL is required')),
        is_default: Yup.boolean(),
      }),
    ),
    devices: Yup.array().of(
      Yup.object().shape({
        id: Yup.string().required(t('Device is required')),
        version: Yup.string().nullable(),
      }),
    ),
    channels: Yup.array().of(
      Yup.object().shape({
        channel: Yup.string(),
        remote_id: Yup.number().nullable(),
        price_override: Yup.number()
          .transform((value, originalValue) => (originalValue === '' ? null : value))
          .nullable()
          .min(0.5, t('Price override must be at least $0.50')),
        visibility: Yup.string().nullable().oneOf(['visible', 'hidden', null]),
      }),
    ),
    videos: Yup.array().of(
      Yup.object().shape({
        youtube_id: Yup.string(),
      }),
    ),
    add_to_cart: Yup.array().of(
      Yup.object().shape({
        listing_id: Yup.number(),
      }),
    ),
    related: Yup.array().of(
      Yup.object().shape({
        listing_id: Yup.number(),
      }),
    ),
    items: Yup.array().of(
      Yup.object().shape({
        id: Yup.string().required(t('Item is required')),
        item_qty: Yup.number().required(t('Item qty is required')),
      }),
    ),

    evaluated_subs: Yup.boolean(),
    large_item: Yup.boolean(),

    attributes: attributeSchema,

    variants: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(t('Variant label is required')),
        options: Yup.array().of(
          Yup.object().shape({
            listing_id: Yup.number().required(t('Listing is required')),
            label: Yup.string().required(t('Label is required')),
          }),
        ),
      }),
    ),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const getDevices = async (models) => {
    try {
      const devices = await Promise.all(
        models.map((model) => get(`/api/devices/find?brand=${encodeURIComponent(model.brand)}&model=${encodeURIComponent(model.model)}&create=1`)),
      );

      return devices.filter((dev) => dev !== null);
    } catch (error) {
      toastr.error(t('Error'), error.message);
      return [];
    }
  };

  const jsx = (
    <>
      {em}
      <Formik
        enableReinitialize
        initialValues={duplicate ? {
          ...entity,
          id: null,
          box_id: undefined,
          box_id_locked: true,
          ship_dims: '5x7x11',
          attributes: entity.attributes.map((x) => ({ ...x, id: null })),
          items: [],
          devices: entity.devices.length > 0 ? entity.devices : entity.items[0].devices,
          videos: entity.videos.map((x) => ({ ...x, id: null })),
          images: [],
          add_to_cart: entity.add_to_cart.map((x) => ({ ...x, id: null })),
          related: [],
          variants: entity.variants.map((x) => ({ ...x, id: null })),
          channels: ['shopjimmy', 'partner_api', 'fidelitone', 'channel_advisor']
            .map((x) => ({
              id: null,
              channel: x,
              remote_id: null,
              price_override: null,
              visibility: null,
            })),
          evaluated_subs: false,
          large_item: false,
        } : {
          ...entity,
          ...(!entity.id ? { box_id: undefined, box_id_locked: true, ship_dims: '5x7x11' } : {}),
        }}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          // Store empty optional channel fields as null so they use listing/channel defaults.
          for (let i = 0; i < values.channels.length; i += 1) {
            if (values.channels[i].remote_id === '') {
              // eslint-disable-next-line no-param-reassign
              values.channels[i].remote_id = null;
            }
            if (values.channels[i].price_override === '') {
              // eslint-disable-next-line no-param-reassign
              values.channels[i].price_override = null;
            }
            if (values.channels[i].visibility === '') {
              // eslint-disable-next-line no-param-reassign
              values.channels[i].visibility = null;
            }
          }

          save(values);
        }}
      >
        {({
          touched, errors, values, setFieldValue,
        }) => (
          <Form id="ListingEditForm" autoComplete="off">
            <Row>
              <Col xxl="7">
                <Card>
                  <CardHeader className="border-bottom">{props.t('Save Listing')}</CardHeader>
                  <CardBody>
                    <Row>
                      <Col md="3">
                        <Nav pills className="flex-column">
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '1',
                              })}
                              onClick={() => {
                                setActiveTab('1');
                              }}
                            >
                              {props.t('General')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '2',
                              })}
                              onClick={() => {
                                setActiveTab('2');
                              }}
                            >
                              {props.t('Attributes')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '3',
                              })}
                              onClick={() => {
                                setActiveTab('3');
                              }}
                            >
                              {props.t('Compatibility')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '4',
                              })}
                              onClick={() => {
                                setActiveTab('4');
                              }}
                            >
                              {props.t('Images')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '5',
                              })}
                              onClick={() => {
                                setActiveTab('5');
                              }}
                            >
                              {props.t('Videos')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '6',
                              })}
                              onClick={() => {
                                setActiveTab('6');
                              }}
                            >
                              {props.t('Add-to-Cart')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '7',
                              })}
                              onClick={() => {
                                setActiveTab('7');
                              }}
                            >
                              {props.t('Related')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '8',
                              })}
                              onClick={() => {
                                setActiveTab('8');
                              }}
                            >
                              {props.t('Variants')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '9',
                              })}
                              onClick={() => {
                                setActiveTab('9');
                              }}
                            >
                              {props.t('Mapping')}
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Col>
                      <Col md="9">
                        <TabContent
                          activeTab={activeTab}
                          className="text-muted mt-4 mt-md-0"
                        >
                          <TabPane tabId="1">
                            <Field name="id" type="hidden" />
                            <Field name="profile_id" type="hidden" />

                            <div className="hstack gap-2">
                              <SpyScraperButton
                                parser="encompass"
                                color="dark"
                                onData={async (data) => {
                                  let title = data.name;
                                  if (data.brand !== undefined) {
                                    setFieldValue('brand', data.brand);
                                    title = title.replace(data.brand, '');
                                    const models = data.models?.map((x) => ({
                                      model: x.model,
                                      brand: x.brand || data.brand,
                                    })) || [];
                                    const devices = await getDevices(models);
                                    setFieldValue('devices', devices?.map((x) => ({
                                      id: x.id, brand: x.brand, model: x.model, version: x.version,
                                    })) || []);
                                  }
                                  if (data.part_number) {
                                    title = title.replace(data.part_number, '');
                                  }
                                  title = `${data.brand} ${data.part_number} ${title.replace(/\s\s+/, ' ')}`.trim().replace(/\s\s+/, ' ');
                                  setFieldValue('title', title);
                                  setFieldValue('price', data.retail);
                                  setFieldValue('sku', `sj-${data.part_number}`);
                                  setFieldValue('images', data.images?.slice(0, 2).filter((x) => x.path.match(/^http/)).map((x, i) => (
                                    { url: x.path, label: `Photo ${i + 1}`, is_default: i === 0 }
                                  )) || []);
                                  if (data.dimensions) {
                                    setFieldValue('ship_dims', data.dimensions);
                                  }
                                  if (data.weight) {
                                    setFieldValue('ship_weight', data.weight);
                                  }
                                  toastr.success(t('Applied mapping data to form'), 'SpyScraper');
                                }}
                              />
                              <SpyScraperButton
                                parser="partsdr"
                                color="dark"
                                onData={async (data) => {
                                  let title = data.name;
                                  if (data.brand !== undefined) {
                                    setFieldValue('brand', data.brand);
                                    title = title.replace(data.brand, '');
                                    const models = data.models?.map((x) => ({
                                      model: x.model,
                                      brand: x.brand || data.brand,
                                    })) || [];
                                    const devices = await getDevices(models);
                                    setFieldValue('devices', devices?.map((x) => ({
                                      id: x.id, brand: x.brand, model: x.model, version: x.version,
                                    })) || []);
                                  }
                                  if (data.part_number) {
                                    title = title.replace(data.part_number, '');
                                  }
                                  title = `${data.brand} ${data.part_number} ${title.replace(/\s\s+/, ' ')}`.trim().replace(/\s\s+/, ' ');
                                  setFieldValue('title', title);
                                  setFieldValue('price', data.retail);
                                  setFieldValue('sku', `sj-${data.part_number}`);
                                  setFieldValue('images', data.images?.slice(0, 2).filter((x) => x.path.match(/^http/)).map((x, i) => (
                                    { url: x.path, label: `Photo ${i + 1}`, is_default: i === 0 }
                                  )) || []);
                                  if (data.dimensions) {
                                    setFieldValue('ship_dims', data.dimensions);
                                  }
                                  if (data.weight) {
                                    setFieldValue('ship_weight', data.weight);
                                  }
                                  toastr.success(t('Applied mapping data to form'), 'SpyScraper');
                                }}
                              />
                            </div>

                            <div className="hstack gap-2">
                              <SpyScraperButton
                                parser="partsdr"
                                color="info"
                                onData={async (data) => {
                                  if (data.brand !== undefined) {
                                    setFieldValue('brand', data.brand);
                                    const models = data.models?.map((x) => ({
                                      model: x.model,
                                      brand: x.brand || data.brand,
                                    })) || [];
                                    const devices = await getDevices(models);
                                    const incomingDevices = devices?.map((x) => ({
                                      id: x.id,
                                      brand: x.brand,
                                      model: x.model,
                                      version: x.version,
                                    })) || [];
                                    const existingDevices = values.devices || [];
                                    const merged = [
                                      ...existingDevices,
                                      ...incomingDevices.filter((incoming) => !existingDevices
                                        .some((existing) => (
                                          existing.id === incoming.id
                                          || (
                                            existing.brand === incoming.brand
                                            && existing.model === incoming.model
                                            && (existing.version || '') === (incoming.version || '')
                                          )
                                        ))),
                                    ];
                                    setFieldValue('devices', merged);
                                  }
                                  toastr.success(t('Applied compatibility to form'), 'SpyScraper');
                                }}
                              >
                                <>
                                  <strong>PartsDr</strong>
                                  <br />
                                  <span>Compatibility Only</span>
                                </>
                              </SpyScraperButton>
                              <SpyScraperButton
                                parser="encompass"
                                color="info"
                                onData={async (data) => {
                                  if (data.brand !== undefined) {
                                    setFieldValue('brand', data.brand);
                                    const models = data.models?.map((x) => ({
                                      model: x.model,
                                      brand: x.brand || data.brand,
                                    })) || [];
                                    const devices = await getDevices(models);
                                    const incomingDevices = devices?.map((x) => ({
                                      id: x.id,
                                      brand: x.brand,
                                      model: x.model,
                                      version: x.version,
                                    })) || [];
                                    const existingDevices = values.devices || [];
                                    const merged = [
                                      ...existingDevices,
                                      ...incomingDevices.filter((incoming) => !existingDevices
                                        .some((existing) => (
                                          existing.id === incoming.id
                                          || (
                                            existing.brand === incoming.brand
                                            && existing.model === incoming.model
                                            && (existing.version || '') === (incoming.version || '')
                                          )
                                        ))),
                                    ];
                                    setFieldValue('devices', merged);
                                  }
                                  toastr.success(t('Applied compatibility to form'), 'SpyScraper');
                                }}
                              >
                                <>
                                  <strong>Encompass</strong>
                                  <br />
                                  <span>Compatibility Only</span>
                                </>
                              </SpyScraperButton>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="title"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Title')}
                                {' '}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col sm={9}>
                                <Field
                                  type="text"
                                  className={`form-control ${(errors.title && touched.title ? 'is-invalid' : '')}`}
                                  id="title"
                                  name="title"
                                />
                                <ErrorMessage
                                  name="title"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="sku"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Sku')}
                                {' '}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col sm={9}>
                                <Field
                                  type="text"
                                  className={`form-control ${(errors.sku && touched.sku ? 'is-invalid' : '')}`}
                                  id="sku"
                                  name="sku"
                                />
                                <ErrorMessage
                                  name="sku"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="condition"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Condition')}
                                {' '}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col sm={9}>
                                <Field
                                  as="select"
                                  className={`form-control ${(errors.condition && touched.condition ? 'is-invalid' : '')}`}
                                  id="condition"
                                  name="condition"
                                >
                                  <option>{props.t('Select...')}</option>
                                  <option value="New">{props.t('Brand New')}</option>
                                  <option value="Like New">{props.t('Like New')}</option>
                                  <option value="Used">{props.t('Used')}</option>
                                  <option value="Refurbished">{props.t('Refurbished')}</option>
                                  <option value="Other">{props.t('Other')}</option>
                                </Field>
                                <ErrorMessage
                                  name="condition"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="brand"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Brand')}
                                {' '}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col sm={9}>
                                <Field
                                  type="text"
                                  className={`form-control ${(errors.brand && touched.brand ? 'is-invalid' : '')}`}
                                  id="brand"
                                  name="brand"
                                />
                                <ErrorMessage
                                  name="brand"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="upc"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('UPC')}
                              </Label>
                              <Col sm={9}>
                                <Field
                                  type="text"
                                  className={`form-control ${(errors.upc && touched.upc ? 'is-invalid' : '')}`}
                                  id="upc"
                                  name="upc"
                                />
                                <ErrorMessage
                                  name="upc"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="ship_weight"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Ship Weight')}
                                {' '}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col sm="auto">
                                <div className="input-group">
                                  <Field
                                    type="text"
                                    className={`form-control ${(errors.ship_weight && touched.ship_weight ? 'is-invalid' : '')}`}
                                    id="weight"
                                    name="ship_weight"
                                  />
                                  <div className="input-group-append">
                                    <span className="input-group-text">LBS</span>
                                  </div>
                                </div>

                                {
                                  errors
                                  && errors.ship_weight
                                  && touched.ship_weight && (
                                    <div className="text-danger pt-1">{errors.ship_weight}</div>
                                  )
                                }
                              </Col>
                            </div>

                            <ListingBoxPicker>
                              <div className="row mt-4 mb-4">
                                <Label
                                  for="ship_dims"
                                  className="col-sm-3 col-form-label"
                                >
                                  {props.t('Ship Dimensions')}
                                  {' '}
                                  <span className="text-danger">*</span>
                                </Label>
                                <Col sm="5">
                                  <div className="input-group">
                                    <Field
                                      type="text"
                                      className={`form-control ${(errors.ship_dims && touched.ship_dims ? 'is-invalid' : '')}`}
                                      id="ship_dims"
                                      name="ship_dims"
                                      placeholder="1x1x1"
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text">Inches</span>
                                    </div>
                                  </div>
                                  {
                                  errors
                                  && errors.ship_dims
                                  && touched.ship_dims && (
                                    <div className="text-danger pt-1">{errors.ship_dims}</div>
                                  )
                                }
                                </Col>
                              </div>

                            </ListingBoxPicker>

                            <div className="row mt-4 mb-4">
                              <Label
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Tags')}
                                {' '}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col sm="9">
                                <TagSelector
                                  id="tag_selector"
                                  initialTags={entity.tags}
                                  allowCreate
                                  predictorTitle={
                                    entity.title !== values.title ? values.title : null
                                  }
                                  onUpdate={(tags) => {
                                    setFieldValue('tags', tags);
                                    updateMatchedCats(tags);
                                    updateAveragePrice(tags, values.sku.substring(0, 7));
                                  }}
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Evaluated for Subs')}
                                {' '}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col>
                                <Field
                                  type="checkbox"
                                  name="evaluated_subs"
                                  className="form-check-input"
                                  id="evaluated_subs"
                                  onChange={() => {
                                    setFieldValue('evaluated_subs', !values.evaluated_subs);
                                  }}
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label className="col-sm-3 col-form-label">
                                {props.t('Large Item')}
                              </Label>
                              <Col>
                                <Field
                                  type="checkbox"
                                  name="large_item"
                                  className="form-check-input"
                                  id="large_item"
                                  aria-describedby="large_item_help"
                                  onChange={() => {
                                    setFieldValue('large_item', !values.large_item);
                                  }}
                                />
                                <small id="large_item_help" className="d-block text-muted mt-2">
                                  {props.t('(Free shipping exempt)')}
                                </small>
                              </Col>
                            </div>

                            <div className="mt-4 mb-4">
                              <h6>{t('Matched Categories')}</h6>

                              {matchedCats.map((x) => (
                                <div key={`matched_cat_${x.id}`} className="mt-2 mb-2">
                                  {x.parent !== null && (
                                    <>
                                      <span>
                                        {x.tree.key}
                                        :
                                      </span>
                                      {' '}
                                      <span className="badge bg-warning text-dark bg-soft">{`${x.parent.name} -> ${x.name}`}</span>
                                    </>
                                  )}
                                  {x.parent === null && (
                                    <>
                                      <span>
                                        {x.tree.key}
                                        :
                                      </span>
                                      {' '}
                                      <span className="badge bg-warning text-dark bg-soft">{x.name}</span>
                                    </>
                                  )}
                                </div>
                              ))}
                            </div>

                            <div className="mt-4 mb-4">
                              <Label
                                for="important"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Important Message')}
                              </Label>
                              <Field
                                component="textarea"
                                className={`form-control ${(errors.important && touched.important ? 'is-invalid' : '')}`}
                                id="important"
                                name="important"
                                rows={5}
                              />
                            </div>

                            <div className="mt-4 mb-4">
                              <Label
                                for="description"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Marketing Description')}
                              </Label>
                              <Field
                                component="textarea"
                                className={`form-control ${(errors.description && touched.description ? 'is-invalid' : '')}`}
                                id="description"
                                name="description"
                                rows={10}
                              />
                              {
                                errors
                                && errors.description
                                && touched.description && (
                                  <div className="text-danger pt-1">{errors.description}</div>
                                )
                              }
                            </div>
                            <div className="mt-3">
                              <Button disabled={aiLoading} size="sm" color="secondary" className="btn-soft-secondary" onClick={() => { generateDescription(values, setFieldValue); }}>{t('Generate Description')}</Button>
                            </div>
                          </TabPane>

                          <TabPane tabId="2">
                            <FieldArray name="attributes" className="mt-3">
                              {(arrayHelpers) => (
                                <div>
                                  <label>{props.t('Attributes/USPs')}</label>
                                  <AttributesFieldset arrayHelpers={arrayHelpers} suggestedFields={['Manufacturer Part Number', 'Visible Number', 'Searchable Term']} />
                                </div>
                              )}
                            </FieldArray>
                          </TabPane>
                          <TabPane tabId="3">
                            <FieldArray name="devices" className="mt-3">
                              {(arrayHelpers) => (
                                <div>
                                  <label>{props.t('Compatible Devices')}</label>
                                  <CompatibilityFieldset arrayHelpers={arrayHelpers} />
                                </div>
                              )}
                            </FieldArray>
                          </TabPane>
                          <TabPane tabId="4">
                            <FieldArray name="images" className="mt-3">
                              {(arrayHelpers) => (
                                <>
                                  <GoogleFiles
                                    onFileUpload={(pubUrl) => {
                                      arrayHelpers.push({ url: pubUrl, label: '', is_default: false });
                                    }}
                                    bucket="sj_base_party_images"
                                  />

                                  <ImagesFieldset arrayHelpers={arrayHelpers} />
                                </>
                              )}
                            </FieldArray>
                          </TabPane>
                          <TabPane tabId="5">
                            <FieldArray name="videos" className="mt-3">
                              {(arrayHelpers) => (
                                <div>
                                  <Button color="primary" size="sm" onClick={() => { arrayHelpers.push({ youtube_id: '' }); }}>{t('Add Video +')}</Button>

                                  {values.videos.map((x, i) => (
                                    <Row key={`video_${i}`} className="mt-4 mb-4">
                                      <Col xxl="6">
                                        <InputGroup className="mt-3 mb-3">
                                          <Field
                                            className="form-control"
                                            name={`videos[${i}].youtube_id`}
                                            placeholder="YouTube video ID"
                                          />
                                          <Button color="danger" onClick={() => { arrayHelpers.remove(i); }}>
                                            <span className="mdi mdi-close-thick" />
                                          </Button>
                                        </InputGroup>

                                        <ErrorMessage
                                          name={`videos[${i}].youtube_id`}
                                          component="div"
                                          className="text-danger pt-2"
                                        />

                                        {x.youtube_id !== '' && (
                                          <iframe width="560" height="315" src={`https://www.youtube.com/embed/${x.youtube_id}`} title="YouTube video player" />
                                        )}
                                      </Col>
                                    </Row>
                                  ))}
                                </div>
                              )}
                            </FieldArray>
                          </TabPane>

                          <TabPane tabId="6">
                            <FieldArray name="add_to_cart" className="mt-3">
                              {(arrayHelpers) => (
                                <div>
                                  <Button color="primary" size="sm" onClick={() => { setAddToCartSearch(true); }}>{t('Recommend Additional Listing +')}</Button>

                                  {
                                    addToCartSearch === false && values.add_to_cart
                                    && values.add_to_cart.length > 0 && (
                                      <BaseGrid
                                        url={url.GET_LISTINGS}
                                        hasSearch={false}
                                        shouldPaginate={false}
                                        shouldUpdate={signal}
                                        list={values.add_to_cart && values.add_to_cart.map(
                                          (x) => (x.child_listing_id),
                                        )}
                                        config={
                                          {
                                            columns: {
                                              thumb: {
                                                label: '',
                                                image: {
                                                  src: (item) => (`/api/listings/thumbnail/${item.id}`),
                                                  class: 'rounded',
                                                  style: { maxHeight: '5rem', maxWidth: '5rem' },
                                                },
                                                translate: false,
                                              },
                                              id: { label: 'ID', sort: true },
                                              sku: { label: 'Sku', sort: true },
                                              title: { label: 'Title', sort: true },
                                              actions: {
                                                label: props.t('Actions'),
                                                actions: [
                                                  {
                                                    key: 'remove',
                                                    icon: 'mdi mdi-close-thick',
                                                    class: 'btn btn-sm btn-soft-danger',
                                                    alt: props.t('Remove'),
                                                    click: (listing) => {
                                                      for (
                                                        let i = 0;
                                                        i < values.add_to_cart.length;
                                                        i += 1
                                                      ) {
                                                        if (
                                                          // eslint-disable-next-line max-len
                                                          listing.id === values.add_to_cart[i].child_listing_id
                                                        ) {
                                                          arrayHelpers.remove(i);
                                                        }

                                                        setSignal(signal + 1);
                                                      }
                                                    },
                                                  },
                                                ],
                                              },
                                            },
                                            pagination: {
                                              sort: 'id',
                                              direction: 'desc',
                                              perPage: 30,
                                            },
                                          }
                                        }
                                      />
                                    )
                                  }

                                  {addToCartSearch === true && (
                                    <BaseGrid
                                      url={url.GET_LISTINGS}
                                      hasSearch
                                      shouldPaginate={false}
                                      config={
                                        {
                                          columns: {
                                            thumb: {
                                              label: '',
                                              image: {
                                                src: (item) => (`/api/listings/thumbnail/${item.id}`),
                                                class: 'rounded',
                                                style: { maxHeight: '5rem', maxWidth: '5rem' },
                                              },
                                              translate: false,
                                            },
                                            id: { label: 'ID', sort: true },
                                            sku: { label: 'Sku', sort: true },
                                            title: { label: 'Title', sort: true },
                                            actions: {
                                              label: props.t('Actions'),
                                              actions: [
                                                {
                                                  key: 'select',
                                                  icon: 'mdi mdi-check-bold',
                                                  class: 'btn btn-sm btn-soft-dark',
                                                  alt: props.t('Select'),
                                                  click: (listing) => {
                                                    arrayHelpers.push({
                                                      child_listing_id: listing.id,
                                                    });

                                                    setAddToCartSearch(false);
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                          pagination: {
                                            sort: 'id',
                                            direction: 'desc',
                                            perPage: 30,
                                          },
                                        }
                                      }
                                    />
                                  )}
                                </div>
                              )}
                            </FieldArray>
                          </TabPane>

                          <TabPane tabId="7">
                            <FieldArray name="related" className="mt-3">
                              {(arrayHelpers) => (
                                <div>
                                  <Button color="primary" size="sm" onClick={() => { setRelatedSearch(true); }}>{t('Add Related Listing +')}</Button>

                                  {relatedSearch === false && (
                                    <BaseGrid
                                      url={url.GET_LISTINGS}
                                      hasSearch={false}
                                      shouldPaginate={false}
                                      shouldUpdate={signal}
                                      list={values.related.map((x) => (x.child_listing_id))}
                                      config={
                                        {
                                          columns: {
                                            thumb: {
                                              label: '',
                                              image: {
                                                src: (item) => (`/api/listings/thumbnail/${item.id}`),
                                                class: 'rounded',
                                                style: { maxHeight: '5rem', maxWidth: '5rem' },
                                              },
                                              translate: false,
                                            },
                                            id: { label: 'ID', sort: true },
                                            sku: { label: 'Sku', sort: true },
                                            title: { label: 'Title', sort: true },
                                            actions: {
                                              label: props.t('Actions'),
                                              actions: [
                                                {
                                                  key: 'remove',
                                                  icon: 'mdi mdi-close-thick',
                                                  class: 'btn btn-sm btn-soft-danger',
                                                  alt: props.t('Remove'),
                                                  click: (listing) => {
                                                    for (
                                                      let i = 0;
                                                      i < values.related.length;
                                                      i += 1
                                                    ) {
                                                      if (
                                                        // eslint-disable-next-line max-len
                                                        listing.id === values.related[i].child_listing_id
                                                      ) {
                                                        arrayHelpers.remove(i);
                                                      }

                                                      setSignal(signal + 1);
                                                    }
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                          pagination: {
                                            sort: 'id',
                                            direction: 'desc',
                                            perPage: 30,
                                          },
                                        }
                                      }
                                    />
                                  )}

                                  {relatedSearch === true && (
                                    <BaseGrid
                                      url={url.GET_LISTINGS}
                                      hasSearch
                                      shouldPaginate={false}
                                      config={
                                        {
                                          columns: {
                                            thumb: {
                                              label: '',
                                              image: {
                                                src: (item) => (`/api/listings/thumbnail/${item.id}`),
                                                class: 'rounded',
                                                style: { maxHeight: '5rem', maxWidth: '5rem' },
                                              },
                                              translate: false,
                                            },
                                            id: { label: 'ID', sort: true },
                                            sku: { label: 'Sku', sort: true },
                                            title: { label: 'Title', sort: true },
                                            actions: {
                                              label: props.t('Actions'),
                                              actions: [
                                                {
                                                  key: 'select',
                                                  icon: 'mdi mdi-check-bold',
                                                  class: 'btn btn-sm btn-soft-dark',
                                                  alt: props.t('Select'),
                                                  click: (listing) => {
                                                    arrayHelpers.push({
                                                      child_listing_id: listing.id,
                                                    });

                                                    setRelatedSearch(false);
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                          pagination: {
                                            sort: 'id',
                                            direction: 'desc',
                                            perPage: 30,
                                          },
                                        }
                                      }
                                    />
                                  )}
                                </div>
                              )}
                            </FieldArray>
                          </TabPane>

                          <TabPane tabId="8">
                            <FieldArray name="variants" className="mt-3">
                              {(arrayHelpers) => (
                                <>
                                  <Button
                                    size="sm"
                                    color="primary"
                                    onClick={
                                      () => setFieldValue('variants', [...values.variants, {
                                        label: 'Condition',
                                      }])
                                    }
                                  >
                                    <span className="mdi mdi-plus" />
                                    {t('Add Variant Option')}
                                  </Button>
                                  {values.variants && values.variants.map((x, i) => (
                                    <>
                                      <Row>
                                        <Col sm="6">
                                          <div className="mt-4 mb-4">
                                            <Label
                                              for={`variants_${i}_label`}
                                              className="col-form-label"
                                            >
                                              {props.t('Group Title')}
                                            </Label>
                                            <InputGroup>
                                              <div>
                                                <Field
                                                  type="text"
                                                  id={`variants_${i}_label`}
                                                  name={`variants[${i}].label`}
                                                  className="form-control"
                                                />
                                                <ErrorMessage
                                                  name={`variants[${i}].label`}
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                              <Button color="danger" onClick={() => { arrayHelpers.remove(i); }}>
                                                <span className="mdi mdi-close-thick" />
                                              </Button>
                                            </InputGroup>
                                          </div>
                                        </Col>
                                        <Col sm="6">
                                          <div className="mt-4 mb-4">
                                            <Label
                                              for={`variants_${i}_own_label`}
                                              className="col-form-label"
                                            >
                                              {props.t('Own Variant Label')}
                                            </Label>
                                            <Field
                                              type="text"
                                              id={`variants_${i}_own_label`}
                                              name={`variants[${i}].own_label`}
                                              className="form-control"
                                            />
                                            <ErrorMessage
                                              name={`variants[${i}].own_label`}
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </div>
                                        </Col>
                                      </Row>

                                      <FieldArray name={`variants[${i}].options`}>
                                        {(optionsHelpers) => (
                                          <div>
                                            {x.options && x.options.map((y, j) => (
                                              <Row key={`variant_${i}_${j}`} className="mt-4 mb-4">
                                                <Col sm="6">
                                                  <Label
                                                    for={`variants_${i}_listings_${j}`}
                                                  >
                                                    {props.t('Variant Option')}
                                                  </Label>
                                                  <Field
                                                    as="select"
                                                    id={`variants_${i}_listings_${j}`}
                                                    name={`variants[${i}].options[${j}].listing_id`}
                                                    className="form-control"
                                                  >
                                                    <option key={`variant_${i}_${j}_${y.id}`} value={y.id}>{`${y.listing.sku} - ${y.listing.title}`}</option>
                                                  </Field>
                                                  <ErrorMessage
                                                    name={`variants[${i}].options[${j}].listing_id`}
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />
                                                </Col>
                                                <Col sm="6">
                                                  <Label
                                                    for={`variants_${i}_listings_${j}_label`}
                                                  >
                                                    {props.t('Variant Label')}
                                                  </Label>
                                                  <InputGroup>
                                                    <div>
                                                      <Field
                                                        type="text"
                                                        id={`variants_${i}_listings_${j}_label`}
                                                        name={`variants[${i}].options[${j}].label`}
                                                        className="form-control"
                                                      />
                                                      <ErrorMessage
                                                        name={`variants[${i}].options[${j}].label`}
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </div>
                                                    <Button color="danger" onClick={() => { optionsHelpers.remove(j); }}>
                                                      <span className="mdi mdi-close-thick" />
                                                    </Button>
                                                  </InputGroup>
                                                </Col>
                                              </Row>
                                            ))}
                                          </div>
                                        )}
                                      </FieldArray>
                                      <ListingMultiSelect
                                        items={
                                          values.variants[i] !== undefined
                                            && values.variants[i].options !== undefined
                                            ? values.variants[i].options : []
                                        }
                                        onChange={(selected) => {
                                          setFieldValue(`variants[${i}].options`, selected);
                                        }}
                                      />
                                    </>
                                  ))}
                                </>
                              )}
                            </FieldArray>
                          </TabPane>

                          <TabPane tabId="9">
                            <div className="mb-3">
                              <Label
                                for="search"
                                className="col-form-label"
                              >
                                {props.t('Search for Data')}
                              </Label>
                              <InputGroup>
                                <input type="text" ref={mapSearchRef} className="form-control" id="search" name="search" />
                                <Button color="primary" type="button" className="ml-2" onClick={() => { setMapSearch(mapSearchRef.current.value); }}>{t('Search')}</Button>
                              </InputGroup>
                            </div>

                            {mapSearch !== null && mapSearch !== '' && (
                              <div className="mt-4">
                                <EncompassMapper
                                  search={mapSearch}
                                  onAccept={(ent) => {
                                    setFieldValue('sku', `sj-${ent.part_number}`);

                                    setFieldValue('devices', ent.devices);
                                    setFieldValue('images', ent.images.map((x, i) => ({ url: x, label: `Photo ${i + 1}`, is_default: i === 0 })));
                                    setFieldValue('brand', ent.manufacturer);

                                    setFieldValue('price', ent.value_usd);
                                    setFieldValue('title', ent.customs_description);
                                    setFieldValue('description', ent.description || '');

                                    if (ent.dimensions) {
                                      setFieldValue('ship_dims', ent.dimensions);
                                    }

                                    setActiveTab('1');
                                  }}
                                />
                              </div>
                            )}
                          </TabPane>
                        </TabContent>
                      </Col>
                    </Row>

                    <hr />
                    <div className="row justify-content-end">
                      <Col sm={9}>
                        <div className="d-flex flex-row-reverse bd-highlight gap-2">
                          <Button
                            type="submit"
                            form="ListingEditForm"
                            color="primary"
                            className="w-md"
                          >
                            {props.t('Submit')}
                          </Button>

                          <Button
                            type="button"
                            color="soft-info"
                            className="w-md text-dark"
                            onClick={() => { history.goBack(); }}
                          >
                            {props.t('Cancel')}
                          </Button>
                        </div>
                      </Col>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col xxl="5">
                <Card>
                  <CardHeader>{props.t('Items Required')}</CardHeader>
                  <CardBody>
                    <ItemFieldset withQty />
                  </CardBody>
                </Card>

                <Card>
                  <CardHeader className="border-bottom">{props.t('Pricing')}</CardHeader>
                  <CardBody>
                    <div className="mt-3">
                      <span>{t('Average Price (based on tags):')}</span>
                      {' '}
                      <strong>$</strong>
                      <strong>{averagePrice.toString()}</strong>
                    </div>

                    <div className="row mt-3 mb-4">
                      <Label
                        for="price"
                        className="col-sm-3 col-form-label"
                      >
                        {props.t('Default Price')}
                        {' '}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col sm="4">
                        <InputGroup>
                          <span className="input-group-text">$</span>
                          <Field
                            type="text"
                            className={`form-control ${(errors.price ? 'is-invalid' : '')}`}
                            id="price"
                            name="price"
                          />
                        </InputGroup>

                        <ErrorMessage
                          name="price"
                          component="div"
                          className="text-danger pt-2"
                        />
                      </Col>
                    </div>
                  </CardBody>
                </Card>

                <Card>
                  <CardHeader className="border-bottom">{props.t('Sales Channels')}</CardHeader>
                  <CardBody>
                    <FieldArray name="channels" className="mt-3">
                      {(arrayHelpers) => (
                        <div>
                          <div className="d-flex flex-wrap gap-2">
                            <Button disabled={values.channels.find((x) => x.channel === 'google_shopping') !== undefined} className="btn-soft-secondary" size="sm" onClick={() => { arrayHelpers.push(newChannel('google_shopping')); }}>{t('Google Shopping +')}</Button>
                            <Button disabled={values.channels.find((x) => x.channel === 'partner_api') !== undefined} className="btn-soft-secondary" size="sm" onClick={() => { arrayHelpers.push(newChannel('partner_api')); }}>{t('Partner API +')}</Button>
                            <Button disabled={values.channels.find((x) => x.channel === 'channel_advisor') !== undefined} className="btn-soft-secondary" size="sm" onClick={() => { arrayHelpers.push(newChannel('channel_advisor')); }}>{t('Rithum +')}</Button>
                            <Button disabled={values.channels.find((x) => x.channel === 'shopjimmy') !== undefined} className="btn-soft-secondary" size="sm" onClick={() => { arrayHelpers.push(newChannel('shopjimmy')); }}>{t('ShopJimmy.com +')}</Button>
                            <Button disabled={values.channels.find((x) => x.channel === 'fidelitone') !== undefined} className="btn-soft-secondary" size="sm" onClick={() => { arrayHelpers.push(newChannel('fidelitone')); }}>{t('Fidelitone +')}</Button>
                          </div>

                          <Row className="g-3 mt-0">
                            {values.channels.map((x, i) => (
                              <Col md="6" key={`channel_${x.channel}`}>
                                <Card
                                  className="listing-channel-card h-100 mb-0"
                                  data-channel={x.channel}
                                >
                                  <CardHeader className="listing-channel-card__header p-2">
                                    <InputGroup size="sm">
                                      <Field
                                        as="select"
                                        className="form-select"
                                        id={`channel_select_${i}_channel`}
                                        name={`channels[${i}].channel`}
                                        aria-label={t('Sales channel')}
                                      >
                                        <option value="" disabled>{t('Select a Channel')}</option>
                                        <option value="channel_advisor">Rithum</option>
                                        <option value="google_shopping">Google Shopping</option>
                                        <option value="shopjimmy">ShopJimmy.com</option>
                                        <option value="partner_api">Partner API</option>
                                        <option value="fidelitone">Fidelitone</option>
                                        <option value="M&E">M&amp;E</option>
                                      </Field>
                                      <Button
                                        color="danger"
                                        className="btn-soft-danger"
                                        title={x.deletion_requested_at ? t('Rithum deletion is already pending') : t('Remove channel')}
                                        disabled={Boolean(x.deletion_requested_at)}
                                        onClick={() => { arrayHelpers.remove(i); }}
                                      >
                                        <span className="mdi mdi-close-thick" />
                                      </Button>
                                    </InputGroup>
                                    <ErrorMessage
                                      name={`channels[${i}].channel`}
                                      component="div"
                                      className="text-danger small pt-1"
                                    />
                                  </CardHeader>

                                  <CardBody className="listing-channel-card__body p-2">
                                    <Row className="g-2">
                                      <Col xs="12">
                                        <Label className="form-label small mb-1" for={`channel_select_${i}_id`}>{t('Remote ID')}</Label>
                                        <Field
                                          type="number"
                                          className="form-control form-control-sm"
                                          id={`channel_select_${i}_id`}
                                          name={`channels[${i}].remote_id`}
                                          placeholder={t('Auto-generated')}
                                        />
                                        <ErrorMessage
                                          name={`channels[${i}].remote_id`}
                                          component="div"
                                          className="text-danger small pt-1"
                                        />
                                      </Col>

                                      <Col xs={x.channel === 'fidelitone' ? '12' : '6'}>
                                        <Label className="form-label small mb-1" for={`channel_select_${i}_price_override`}>{t('Price override')}</Label>
                                        <InputGroup size="sm">
                                          <span className="input-group-text">$</span>
                                          <Field
                                            type="number"
                                            min="0.5"
                                            step="0.01"
                                            className="form-control"
                                            id={`channel_select_${i}_price_override`}
                                            name={`channels[${i}].price_override`}
                                            placeholder={t('Default')}
                                          />
                                        </InputGroup>
                                        <ErrorMessage
                                          name={`channels[${i}].price_override`}
                                          component="div"
                                          className="text-danger small pt-1"
                                        />
                                      </Col>

                                      {x.channel !== 'fidelitone' && (
                                        <Col xs="6">
                                          <Label className="form-label small mb-1" for={`channel_select_${i}_visibility`}>{t('Visibility')}</Label>
                                          <Field
                                            as="select"
                                            className="form-select form-select-sm"
                                            id={`channel_select_${i}_visibility`}
                                            name={`channels[${i}].visibility`}
                                            value={x.visibility || ''}
                                          >
                                            <option value="">{t('Use default')}</option>
                                            <option value="visible">{t('Visible')}</option>
                                            <option value="hidden">{t('Hidden')}</option>
                                          </Field>
                                        </Col>
                                      )}

                                      {priceOverrideExceedsDefault(
                                        x.price_override,
                                        values.price,
                                      ) && (
                                        <Col xs="12">
                                          <div
                                            className="listing-channel-card__price-warning"
                                            role="status"
                                            aria-live="polite"
                                          >
                                            <span className="mdi mdi-alert-circle-outline" aria-hidden="true" />
                                            <span>
                                              {t('Override is higher than the default price of {{price}}.', {
                                                price: `$${Number(values.price).toFixed(2)}`,
                                              })}
                                            </span>
                                          </div>
                                        </Col>
                                      )}
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                            ))}
                          </Row>

                          <p className="mt-2">
                            <small className="text-muted">
                              {t('Blank Remote IDs are generated through the channel API. Blank overrides use the listing and channel defaults.')}
                            </small>
                          </p>
                        </div>
                      )}
                    </FieldArray>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

ListingForm.defaultProps = {
  entity: {
    sku: '',
    upc: '',
    ship_weight: 1,
    ship_dims: '5x7x11',
    description: '',
    items: [],
    tags: [],
    images: [],
    devices: [],
    attributes: [],
    videos: [],
    add_to_cart: [],
    related: [],
    variants: [],
    evaluated_subs: false,
    large_item: false,
  },
  onSuccess: () => { },
  duplicate: false,
};

ListingForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
  duplicate: PropTypes.bool,
};

export default connect((state) => ({

}), {})(withTranslation()(ListingForm));
